import { PurchasePayment } from "../models/purchase-payment";
import { httpGet, httpPost } from "./http-client";

const apiUrl = '/api/purchasepayments';

export const getPurchasePayments = () => httpGet<PurchasePayment[]>(`${apiUrl}/all`);
export const payPurchasePayment = (purchasePayment: PurchasePayment) => httpPost<PurchasePayment>(`${apiUrl}/pay`, purchasePayment);
